import styles from "./RectInkEditor.module.scss";
import { FC, useCallback, useRef } from "react";
import { InkEditorProps } from "./InkEditor";
import { CornerHandle } from "../../views/CornerHandle";
import { Offset } from "../../model/offset";
import { HorizontalHandle } from "../../views/HorizontalHandle";
import { VerticalHandle } from "../../views/VerticalHandle";
import {
  movePixelateInkBottomEdge,
  movePixelateInkBottomLeftCorner,
  movePixelateInkBottomRightCorner,
  movePixelateInkLeftEdge,
  movePixelateInkRightEdge,
  movePixelateInkTopEdge,
  movePixelateInkTopLeftCorner,
  movePixelateInkTopRightCorner,
  PixelateInk,
} from "../../model/tool/pixelate";

export const PixelateInkEditor: FC<InkEditorProps<PixelateInk>> = (props) => {
  const { onChange } = props;
  const draggingInkRef = useRef<PixelateInk>();

  const handleDragStart = useCallback(() => {
    draggingInkRef.current = props.ink;
  }, [props.ink]);

  const handleTopEdgeDragMove = useCallback(
    (offset: Offset) => {
      if (draggingInkRef.current === undefined) {
        return;
      }
      onChange(movePixelateInkTopEdge(draggingInkRef.current, offset));
    },
    [onChange],
  );

  const handleRightEdgeDragMove = useCallback(
    (offset: Offset) => {
      if (draggingInkRef.current === undefined) {
        return;
      }
      onChange(movePixelateInkRightEdge(draggingInkRef.current, offset));
    },
    [onChange],
  );

  const handleBottomEdgeDragMove = useCallback(
    (offset: Offset) => {
      if (draggingInkRef.current === undefined) {
        return;
      }
      onChange(movePixelateInkBottomEdge(draggingInkRef.current, offset));
    },
    [onChange],
  );

  const handleLeftEdgeDragMove = useCallback(
    (offset: Offset) => {
      if (draggingInkRef.current === undefined) {
        return;
      }
      onChange(movePixelateInkLeftEdge(draggingInkRef.current, offset));
    },
    [onChange],
  );

  const handleTopLeftCornerDragMove = useCallback(
    (offset: Offset, event: MouseEvent) => {
      if (draggingInkRef.current === undefined) {
        return;
      }
      onChange(movePixelateInkTopLeftCorner(draggingInkRef.current, offset, event.shiftKey));
    },
    [onChange],
  );

  const handleTopRightCornerDragMove = useCallback(
    (offset: Offset, event: MouseEvent) => {
      if (draggingInkRef.current === undefined) {
        return;
      }
      onChange(movePixelateInkTopRightCorner(draggingInkRef.current, offset, event.shiftKey));
    },
    [onChange],
  );

  const handleBottomRightCornerDragMove = useCallback(
    (offset: Offset, event: MouseEvent) => {
      if (draggingInkRef.current === undefined) {
        return;
      }
      onChange(movePixelateInkBottomRightCorner(draggingInkRef.current, offset, event.shiftKey));
    },
    [onChange],
  );

  const handleBottomLeftCornerDragMove = useCallback(
    (offset: Offset, event: MouseEvent) => {
      if (draggingInkRef.current === undefined) {
        return;
      }
      onChange(movePixelateInkBottomLeftCorner(draggingInkRef.current, offset, event.shiftKey));
    },
    [onChange],
  );

  const handleDragEnd = useCallback(() => {
    draggingInkRef.current = undefined;
  }, []);

  return (
    <div className={styles.container} onDoubleClick={() => console.log("double click")}>
      <div style={{ top: 0, left: 0 }} className={styles.horizontalHandleWrapper}>
        <HorizontalHandle
          zoom={props.zoom}
          onDragStart={handleDragStart}
          onDragMove={handleTopEdgeDragMove}
          onDragEnd={handleDragEnd}
        />
      </div>
      <div style={{ top: 0, left: "100%" }} className={styles.verticalHandleWrapper}>
        <VerticalHandle
          zoom={props.zoom}
          onDragStart={handleDragStart}
          onDragMove={handleRightEdgeDragMove}
          onDragEnd={handleDragEnd}
        />
      </div>
      <div style={{ top: "100%", left: 0 }} className={styles.horizontalHandleWrapper}>
        <HorizontalHandle
          zoom={props.zoom}
          onDragStart={handleDragStart}
          onDragMove={handleBottomEdgeDragMove}
          onDragEnd={handleDragEnd}
        />
      </div>
      <div style={{ top: 0, left: 0 }} className={styles.verticalHandleWrapper}>
        <VerticalHandle
          zoom={props.zoom}
          onDragStart={handleDragStart}
          onDragMove={handleLeftEdgeDragMove}
          onDragEnd={handleDragEnd}
        />
      </div>
      <div style={{ top: 0, left: 0 }} className={styles.cornerHandleWrapper}>
        <CornerHandle
          orientation="nwse"
          zoom={props.zoom}
          onDragStart={handleDragStart}
          onDragMove={handleTopLeftCornerDragMove}
          onDragEnd={handleDragEnd}
        />
      </div>
      <div style={{ top: 0, left: "100%" }} className={styles.cornerHandleWrapper}>
        <CornerHandle
          orientation="nesw"
          zoom={props.zoom}
          onDragStart={handleDragStart}
          onDragMove={handleTopRightCornerDragMove}
          onDragEnd={handleDragEnd}
        />
      </div>
      <div style={{ top: "100%", left: "100%" }} className={styles.cornerHandleWrapper}>
        <CornerHandle
          orientation="nwse"
          zoom={props.zoom}
          onDragStart={handleDragStart}
          onDragMove={handleBottomRightCornerDragMove}
          onDragEnd={handleDragEnd}
        />
      </div>
      <div style={{ top: "100%", left: 0 }} className={styles.cornerHandleWrapper}>
        <CornerHandle
          orientation="nesw"
          zoom={props.zoom}
          onDragStart={handleDragStart}
          onDragMove={handleBottomLeftCornerDragMove}
          onDragEnd={handleDragEnd}
        />
      </div>
    </div>
  );
};
